import * as Yup from "yup";

/**
 * Validation schema for the single story-idea create form.
 */
export const validationSchema = Yup.object({
  title: Yup.string().required("Please enter a title").max(255, "Title must be 255 characters or less"),
  news_hook: Yup.string()
    .required("Please enter a news hook")
    .max(10000, "News hook must be 10,000 characters or less"),
  topics: Yup.array().of(Yup.string()).min(1, "Please add at least one topic").required("Topics are required"),
  marketing_persona_id: Yup.string().required("Please select a marketing persona"),
});

export default validationSchema;
